import React from "react";
import ContactUs from "../Images/FAQ.svg";
const QuoteFooter = () => {
    //console.log(props)

    return (
        <>
            <div className="quote_footer_main">
                <div className="quote-footer-container">
                    <img className="quote-right-container-img" src={ContactUs} alt="Did You Know" />
                    <div className="quote-footer-right-content">
                        <h4>Did you know?</h4>
                        <p>An honest error can put even the most skilled professionals in legal hot water. In order to prevent one misstep from becoming a financial nightmare, professional indemnity insurance helps cover claims and legal expenses. Because protecting your profession must also include protecting yourself.</p>
                    </div>
                </div>
            </div>
        </>
    )
}
export default QuoteFooter;